import React from 'react';

import cx from 'classnames';

import { isEmpty } from '../../validation/Validator';
import TextWithIcon from '../TextWithIcon';
import { IFieldErrorProps } from './interfaces';

export const isError = (meta: any = {}): boolean =>
  !!(
    meta.touched &&
    ((meta.error && !isEmpty(meta.error)) || (meta.submitError && !meta.dirtySinceLastSubmit))
  );
// TODO: ignoreDirty is needed for array of fields, after manipulation fields that are not dirty become dirty

const FieldError: React.FC<IFieldErrorProps> = ({
  inline = false,
  meta = {},
  validationProps = undefined,
  children,
  'data-testid': dataTestId,
}) => (
  <div
    className={cx(!inline && 'mb-4', inline && 'inline-block w-full', isError(meta) && 'text-red')}
  >
    {children}
    {isError(meta) && (
      <TextWithIcon
        data-testid={dataTestId}
        icon="images/global/icons/16/error.svg"
        iconTitle="Error"
        className="mt-2 font-medium"
        componentClassName="inline-flex"
        variant="caption"
        {...validationProps}
      >
        <span data-testid={`${dataTestId}-error-text`}>{meta.error || meta.submitError}</span>
      </TextWithIcon>
    )}
  </div>
);

export default FieldError;
